import React, { Component } from "react";
import "../assets/style.css";
import { BreadCrumb } from "primereact/breadcrumb";
import { Tabs, Tab } from "react-bootstrap";
import PopupForm from "../components/PopupForm";
import EntPopupForm from "../components/EntPopupForm";
import AddNewApp from "../pages/AddNewApp";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Link } from "react-router-dom";
import Loader from "../components/Loader";
import { Tooltip } from "primereact/tooltip";
import { loadGapiInsideDOM } from "gapi-script";
import {
  getAppManagemnetUrl,
  getUserProfileUrl,
  baseUrl,
} from "../service/ApiUrls";
import {
  AppTypeEnum,
  ActionType,
  ActionAssign,
  OSTypeEnum,
  DeleteType,
} from "../Enums";
import api from "../service/ApiService";
import Assign from "../components/Assign";
import { Dialog } from "primereact/dialog";
import ErrorDialog from "../components/ErrorDialog";
import { Paginator } from "primereact/paginator";
import { OverlayPanel } from "primereact/overlaypanel";
import { confirmAlert } from "react-confirm-alert";
const helpIcon = require("../assets/icons/help_icon.png");

let deafultIconString =
  "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";
//const gapi;
var gapi;
export class AppManagement extends Component {
  constructor() {
    super();
    this.state = {
      systemApps: [],
      enterpriseApps: [],
      playStoreApps: [],
      isLoading: true,
      sysfirst: 0,
      sysrows: 8,
      systotalRecords: 8,
      entfirst: 0,
      entrows: 8,
      enttotalRecords: 8,
      playfirst: 0,
      playrows: 8,
      playpage: 0,
      entpage: 0,
      syspage: 0,
      playtotalRecords: 8,
      isEnt: false,
      isPlayStore: false,
      AddPlayStore: false,
    };

    this.onPageChange = this.onPageChange.bind(this);
  }

  onDialogueHide = () => {
    this.setState({
      AddPlayStore: false,

      parentFrameUrl: null,
      iframeType: 0,
      appId: null,
      manageConfigurationTemplateId: null,
      webToken: null,
      iframeUrl: null,
    });
  };
  onPageChange = (tag) => (event) => {
    console.log("event", event, "tag", tag);
    if (tag === "sys") {
      this.setState(
        {
          sysfirst: event.first,
          syspage: event.page,
          sysrows: event.rows,
          currentPage: event.page + 1,
        },
        () => {
          this.callgetAppListByType({
            first: this.state.syspage,
            limit: this.state.sysrows,
          });
        }
      );
    } else if (tag === "ent") {
      this.setState(
        {
          entfirst: event.first,
          entpage: event.page,
          entrows: event.rows,
          currentPage: event.page + 1,
        },
        () => {
          this.callgetAppListByType({
            apptype: AppTypeEnum.ENTERPRISEAPP,
            first: this.state.entpage,
            limit: this.state.entrows,
          });
        }
      );
    } else {
      this.setState(
        {
          playfirst: event.first,
          playrows: event.rows,
          playpage: event.page,
          currentPage: event.page + 1,
        },
        () => {
          this.callgetAppListByType({
            apptype: AppTypeEnum.PLAYSTOREAPP,
            first: this.state.playpage,
            limit: this.state.playrows,
          });
        }
      );
    }
  };

  webcallForProfile = () => {
    this.setState({ isLoading: true }, () => {
      api.get(baseUrl + "/android-enterprise").then((res) => {
        if (res.data.result.isError === false) {
          this.setState(
            {
              ...res.data.data,
              isLoading: false,
              hasEnterpriseSetup:
                res.data.data !== null && res.data.data.status !== 0,
            },
            async () => {
              gapi = await loadGapiInsideDOM();
              let response = await this.callgetAppListByType();
              if (response !== undefined && response.result.isError === false) {
                this.setState({
                  systemApps: response.data.content,
                  isLoading: false,
                });
              }
            }
          );
        } else {
          this.setState({ isLoading: false });
        }
      });
    });
  };

  callPlayStoreApi = async () => {
    let response = await this.callgetAppListByType({
      apptype: 3,
      first: this.state.playpage,
      limit: this.state.playrows,
    });
    if (response !== undefined && response.result.isError === false) {
      this.setState({
        playStoreApps: response.data.content,
        isPlayStore: true,
        isLoading: false,
      });
    } else {
      this.setState({ isLoading: false, AddPlayStore: false }, () => {
        confirmAlert({
          title: "Error Message",
          message: <p className="mod-p">{response.data.result.errorMsg}</p>,
          buttons: [
            {
              label: "Ok",
              onClick: () => {},
            },
          ],
        });
      });
    }
  };

  callgetAppListByType = async ({
    apptype = AppTypeEnum.SYSTEMAPP,
    first = apptype === AppTypeEnum.SYSTEMAPP
      ? this.state.syspage
      : this.state.entpage,
    limit = this.state.sysrows,
    filter = null,
  } = {}) => {
    return api
      .get(getAppManagemnetUrl, {
        params: {
          apptype,
          first,
          limit,
          filter,
        },
      })
      .then((res) => {
        const {
          data,
          result: { isError, errMsg, statusCode },
        } = res.data;
        //console.log(data, "isError", isError, "error msg", errMsg);
        //this.setState({ systemApps: data.content, isLoading: false });
        if (isError === false) {
          if (AppTypeEnum.SYSTEMAPP === apptype)
            this.setState({
              systemApps: data.content,
              isLoading: false,
              systotalRecords: data.totalRecords,
            });
          else if (AppTypeEnum.ENTERPRISEAPP === apptype) {
            this.setState({
              enterpriseApps: data.content,
              isLoading: false,
              enttotalRecords: data.totalRecords,
            });
          } else if (AppTypeEnum.PLAYSTOREAPP === apptype) {
            this.setState({
              playStoreApps: data.content,
              isLoading: false,
              playtotalRecords: data.totalRecords,
            });
          }
          return { data, result: { isError, errMsg, statusCode } };
          // else return { result: { isError, errMsg, statusCode } };
        } else {
          this.setState({
            isLoading: false,
            textInLoader: res.data.result.errorMsg,
            isError: true,
          });
        }
      })
      .catch((err) => {
        console.log(err.response);
        this.setState({ isLoading: false });
      });
  };
  cusPopup = (val) => () => {
    this.setState({ isLoading: true, isEnt: val === 1 }, async () => {
      if (val === 1) {
        let responseent = await this.callgetAppListByType({
          apptype: AppTypeEnum.ENTERPRISEAPP,
          first: this.state.entpage,
          limit: this.state.entrows,
        });
        if (responseent !== undefined && responseent.result.isError === false) {
          this.setState({
            enterpriseApps: responseent.data.content,
            isPlayStore: false,
            isLoading: false,
          });
        }
      } else if (val === 0) {
        //alert("Hello");
        let response = await this.callgetAppListByType({
          apptype: AppTypeEnum.SYSTEMAPP,
          first: this.state.syspage,
          limit: this.state.sysrows,
        });
        if (response !== undefined && response.result.isError === false) {
          this.setState({
            systemApps: response.data.content,
            isPlayStore: false,
            isLoading: false,
          });
        }
      } else if (val === 2) {
        //alert("Hello");
        this.callPlayStoreApi();
      }
    });
  };

  callDelete = ({
    appId = this.state.appId,
    deleteType = DeleteType.APPDELETE,
    actionType = ActionType.DELETE_UNINSTALL,
    id,
  } = {}) => {
    let data = {
      id: id,
      appId: appId,
      deleteType: deleteType,
      actionType: actionType,
    };
    api
      .delete(getAppManagemnetUrl, {
        data,
        //headers: { aa: "aa" },
      })
      .then((res) => {
        //console.log("uninstall response", res);
        if (res.data.result.isError === false) {
          //this.setState({ isSuccess: true });
          this.callPlayStoreApi();
          //this.props.history.push("/app-management");
          //window.location = process.env.PUBLIC_URL + "/app-management";
        } else {
          this.setState({ showLoader: false }, () => {
            confirmAlert({
              title: "Error Message",
              message: (
                <p className="mod-p">
                  {res.data.result.statusCode + " " + res.data.result.errorMsg}
                </p>
              ),
              buttons: [
                {
                  label: "Ok",
                  onClick: () => {},
                },
              ],
            });
          });
          // this.setState({
          //   textInLoader:
          //     res.data.result.statusCode +
          //     " " +
          //     res.data.result.errorMsg,
          // });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  callpostwebtokenPlaystore = ({
    parentFrameUrl = "https://ibbl.mobionizer.com/app-management",
    iframeType = 0,
    appId = "602cb5000e555352dc15b059",
    objectTopass,
  } = {}) => {
    let dataToSend =
      objectTopass === undefined
        ? {
            parentFrameUrl: parentFrameUrl,
            iframeType: iframeType,
            appId: appId,
          }
        : {
            parentFrameUrl: parentFrameUrl,
            iframeType: iframeType,
            appId: appId,
            manageConfigurationTemplateId:
              objectTopass.manageConfigurationTemplateId,
          };
    console.log("object to pass", objectTopass);
    api.post(baseUrl + "/app-management/webtoken", dataToSend).then((res) => {
      if (res.data.result.isError === false) {
        this.setState(
          { ...res.data.data, isLoading: false, AddPlayStore: true },
          async () => {
            gapi = await loadGapiInsideDOM();
            var gurl =
              this.state.iframeUrl !== undefined && this.state.iframeUrl;
            var objectToSelect;
            gapi.load("gapi.iframes", () => {
              var options = {
                url: gurl,
                where: document.getElementById("container"),
                attributes: {
                  style: "width: 1200px; height:800px",
                  scrolling: "yes",
                },
              };

              var iframe = gapi.iframes.getContext().openChild(options);
              const that = this;

              iframe.register(
                "onconfigupdated",
                (event) => {
                  console.log(event);
                  this.callUpdatePlayStoreApi({
                    id: objectTopass.id,
                    appId: objectTopass.appId,
                    appName: objectTopass.appName,
                    manageConfigurationTemplateId: event.mcmId,
                  });
                },
                gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER
              );

              iframe.register(
                "onconfigdeleted",
                (event) => {
                  console.log(event);
                  this.callUpdatePlayStoreApi({
                    id: objectTopass.id,
                    appId: objectTopass.appId,
                    appName: objectTopass.appName,
                    manageConfigurationTemplateId: null,
                  });
                },
                gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER
              );

              iframe.register(
                "onproductselect",
                (event) => {
                  console.log("event", event);
                  objectToSelect = event;
                  that.setState(
                    {
                      AddPlayStore: false,
                      productSelected: objectToSelect,
                    },
                    () => {
                      if (objectToSelect.action === "approved") {
                        this.callPostAppManagementApi({
                          appName: this.state.productSelected.packageName,
                          appId: this.state.productSelected.packageName,
                          appType: 3,
                          osType: OSTypeEnum.ANDROID,
                        });
                      } else if (objectToSelect.action === "selected") {
                        this.callPostAppManagementApi({
                          appName: this.state.productSelected.packageName,
                          appId: this.state.productSelected.packageName,
                          appType: 3,
                          osType: OSTypeEnum.ANDROID,
                        });
                      } else {
                        this.callDelete({
                          id: appId,
                          appId: this.state.productSelected.packageName,
                          deleteType: 0,
                          actionType: 0,
                        });
                      }
                    }
                  );
                },
                gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER
              );
            });
            // this.setState({
            //   productSelected: objectToSelect,
            //   AddPlayStore: false,
            // });
          }
        );
      } else {
        this.setState({ isLoading: false, AddPlayStore: false }, () => {
          confirmAlert({
            title: "Error Message",
            message: <p className="mod-p">{res.data.result.errorMsg}</p>,
            buttons: [
              {
                label: "Ok",
                onClick: () => {},
              },
            ],
          });
        });
      }
    });
  };
  onDialogueHideError = () => {
    this.setState({ isError: false });
  };

  callUpdatePlayStoreApi = ({
    apkSize = null,
    appDownloadUrl = null,
    appId = null,
    appLogoBase64 = null,
    appName = null,
    appStatus = 0,
    appType = 3,
    description = null,
    deviceIds = null,
    fileTempId = null,
    groupIds = null,
    id = null,
    isSupportManageConfiguration = true,
    isVisible = true,
    logoTempId = null,
    manageConfigurationTemplateId = null,
    managedAppSource = 0,
    osType = 0,
    profileIds = null,
    releasNote = null,
    versionCode = 0,
    versionName = "0",
  } = {}) => {
    let dataToSend = {
      apkSize: apkSize,
      appDownloadUrl: appDownloadUrl,
      appId: appId,
      appLogoBase64: appLogoBase64,
      appName: appName,
      appStatus: appStatus,
      appType: appType,
      description: description,
      deviceIds: deviceIds,
      fileTempId: fileTempId,
      groupIds: groupIds,
      id: id,
      isSupportManageConfiguration: isSupportManageConfiguration,
      isVisible: isVisible,
      logoTempId: logoTempId,
      manageConfigurationTemplateId: manageConfigurationTemplateId,
      managedAppSource: managedAppSource,
      osType: osType,
      profileIds: profileIds,
      releasNote: releasNote,
      versionCode: versionCode,
      versionName: versionName,
    };

    api
      .put(baseUrl + "/app-management/" + id, dataToSend)
      .then((res) => {
        if (res.data.result.isError === false) {
          this.setState({ AddPlayStore: false }, () => {
            this.callPlayStoreApi();
          });
        } else if (res.data.result.isError === true) {
          this.setState({ AddPlayStore: false }, () => {
            confirmAlert({
              title: "Error Message",
              message: <p className="mod-p">{res.data.result.errorMsg}</p>,
              buttons: [
                {
                  label: "Ok",
                  onClick: () => {},
                },
              ],
            });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  callPostAppManagementApi = ({
    appName = this.state.appName,
    appId = this.state.appId,
    versionName,
    versionCode,
    appType = AppTypeEnum.PLAYSTOREAPP,
    osType = OSTypeEnum.ANDROID,
    logoTempId,
    profileIds,
    groupIds,
    deviceIds,
    isLatest,
  } = {}) => {
    let data = {
      appName,
      appId,
      versionName,
      versionCode,
      appType,
      osType,
      logoTempId,
      profileIds,
      groupIds,
      deviceIds,
      isLatest,
    };

    api
      .post(getAppManagemnetUrl + "/add", data)
      .then((res) => {
        if (res.data.result.isError === false) {
          this.callPlayStoreApi();
        }
      })
      .catch((err) => console.log(err));
  };

  componentDidMount = () => {
    //this.cusPopup(0);
    this.webcallForProfile();
  };

  onDialogueLoaderHide = () => {
    this.setState({ isLoading: false });
  };

  render() {
    const items = [
      { label: "Dashboard", url: "dashboard" },
      { label: "App Management" },
    ];
    const home = { icon: "pi pi-home", url: "dashboard" };

    const intSysApplist = this.state.systemApps;
    const sysApplist = intSysApplist.map((e, i) => {
      return (
        <div
          key={i}
          className="p-col-12 p-md-4 p-lg-3 p-xl-3 p-sm-6"
          style={{ display: "inline-block" }}
        >
          <div className="a-list">
            <div className="list-blcok">
              <img
                src={`data:image/jpeg;base64,${
                  e.appLogoBase64 !== undefined && e.appLogoBase64 !== null
                    ? e.appLogoBase64
                    : deafultIconString
                }`}
                alt={e.appName}
                width="100%"
                height="100%"
                className="list-img"
              />
            </div>
            <Tooltip
              target=".list-title"
              position="bottom"
              mouseTrack
              mouseTracktop={25}
            />
            <span className="list-title app-title" data-pr-tooltip={e.appName}>
              {e.appName}
            </span>
            <span className="list-link">
              <Assign
                name={`Assign for App ${e.appName}`}
                fromModule="appManagement"
                dataToSend={e}
                actionType={ActionAssign.ASSIGN}
              />
              <PopupForm e={e} callParentApi={this.callgetAppListByType} />
              <Assign
                name={`Un-Assign for App ${e.appName}`}
                fromModule="appManagement"
                dataToSend={e}
                actionType={ActionAssign.UNASSIGN}
                versionCall="version-list"
              />
            </span>
          </div>
        </div>
      );
    });
    const intApplist = this.state.enterpriseApps;
    const intApplistPlay =
      this.state.playStoreApps !== undefined && this.state.playStoreApps;

    const entApplist = intApplist.map((e, index) => {
      return (
        <div
          className="p-col-12 p-md-3 p-xl-3 p-sm-6"
          style={{ display: "inline-block" }}
          key={index}
        >
          <div className="a-list">
            <div className="list-blcok">
              <img
                src={`data:image/jpeg;base64,${
                  e.appLogoBase64 !== undefined && e.appLogoBase64 !== null
                    ? e.appLogoBase64
                    : deafultIconString
                }`}
                alt={e.img}
                width="40px"
                className="list-img"
              />
            </div>
            <Tooltip
              target=".list-title"
              position="bottom"
              mouseTrack
              mouseTracktop={25}
            />
            <span className="list-title app-title" data-pr-tooltip={e.appName}>
              {e.appName}
            </span>
            <span className="list-link">
              <Assign
                name={`Assign for App ${e.appName}`}
                fromModule="appManagement"
                dataToSend={e}
                actionType={ActionAssign.ASSIGN}
              />
              <Link
                className="custom-a"
                to={{
                  pathname: "/entmanage",
                  search: "",
                  hash: "",
                  state: { e: e },
                }}
              >
                <Tooltip
                  target=".pi-list"
                  position="top"
                  mouseTrack
                  mouseTracktop={20}
                />
                <i
                  className="pi pi-list"
                  data-pr-tooltip="Manage"
                  style={{ fontSize: "1em" }}
                ></i>
              </Link>
              <Assign
                name={`Un-Assign for App ${e.appName}`}
                fromModule="appManagement"
                dataToSend={e}
                actionType={ActionAssign.UNASSIGN}
                versionCall="version-list"
              />
            </span>
          </div>
        </div>
      );
    });

    const playstore = intApplistPlay.map((e, index) => {
      return (
        <div
          className="p-col-12 p-md-3 p-xl-3 p-sm-6"
          style={{ display: "inline-block" }}
          key={index}
        >
          <div className="a-list2">
            <div className="list-blcok2">
              <img
                src={`data:image/jpeg;base64,${
                  e.appLogoBase64 !== undefined && e.appLogoBase64 !== null
                    ? e.appLogoBase64
                    : deafultIconString
                }`}
                alt={e.img}
                width="40px"
                className="list-img"
              />
            </div>
            <Tooltip
              target=".list-title"
              position="bottom"
              mouseTrack
              mouseTracktop={25}
            />
            <span className="list-title app-title" data-pr-tooltip={e.appName}>
              {e.appName}
            </span>
            <Tooltip
              target=".list-title2"
              position="bottom"
              mouseTrack
              mouseTracktop={25}
            />
            <span className="list-title2 app-title" data-pr-tooltip={e.appId}>
              {e.appId}
            </span>
            <span className="list-link">
              <Assign
                name={`Assign for App ${e.appName}`}
                fromModule="appManagement"
                dataToSend={e}
                actionType={ActionAssign.ASSIGN}
              />
              {/* <Link
                className="custom-a"
                to={{
                  pathname: "/entmanage",
                  search: "",
                  hash: "",
                  state: { e: e },
                }}
              > */}
              <Tooltip
                target=".pi-trash"
                position="top"
                mouseTrack
                mouseTracktop={25}
              />
              <i
                className="pi pi-trash"
                data-pr-tooltip="Remove"
                style={{ fontSize: "1em", cursor: "pointer" }}
                onClick={() => {
                  console.log("E", e);
                  this.setState({ isLoading: true }, () => {
                    this.callpostwebtokenPlaystore({
                      parentFrameUrl: window.location.href,
                      iframeType: 0,
                      appId: e.id,
                    });
                  });
                }}
              ></i>
              {/* </Link> */}
              <Assign
                name={`Un-Assign for App ${e.appName}`}
                fromModule="appManagement"
                dataToSend={e}
                actionType={ActionAssign.UNASSIGN}
                versionCall="version-list"
                aytpe="unassign"
              />
              {e.isSupportManageConfiguration === true ? (
                <>
                  <Tooltip
                    target=".pi-cog"
                    position="top"
                    mouseTrack
                    mouseTracktop={25}
                  />
                  <i
                    className="pi pi-cog"
                    data-pr-tooltip="Manage Configuration"
                    style={{ fontSize: "1em", cursor: "pointer" }}
                    onClick={() => {
                      console.log("E", e);
                      this.setState({ isLoading: true }, () => {
                        this.callpostwebtokenPlaystore({
                          parentFrameUrl: window.location.href,
                          iframeType: 1,
                          appId: e.id,
                          objectTopass: e,
                        });
                      });
                    }}
                  ></i>
                </>
              ) : (
                ""
              )}
            </span>
          </div>
        </div>
      );
    });
    return (
      <div className="p-col-12 p-grid">
        <div className="p-col-12 p-lg-12 p-ll">
          <div className="p-col-9 inline-b p-ll">
            <BreadCrumb model={items} home={home} />
          </div>
          <div className="p-col-3 inline-b">
            <img
              src={helpIcon}
              width="20"
              height="20"
              onClick={(e) => this.op.toggle(e)}
              style={{
                marginBottom: "15px",
                float: "right",
                cursor: "pointer",
              }}
            />
          </div>
          <OverlayPanel
            ref={(el) => (this.op = el)}
            id="overlay_panel"
            showCloseIcon={true}
          >
            <div
              className="col"
              style={{
                width: "fit-content",
                maxWidth: "300px",
                padding: "0px",
              }}
            >
              <div className="helptip-title">
                <b>How to : App Management</b>
              </div>
              <div className="helptip-des">
                System stores all apps information with their available versions
                into COMMLINK App Store. Users can upload/update new/existing
                app and assign those apps to the devices based on
                profiles/groups/devices.
                <br />
                <br />
                <b>Notes:</b> To add a system-app, users need to insert App Name
                only. For enterprise-app, users need to upload the apk file.
              </div>
            </div>
          </OverlayPanel>
        </div>
        <div className="p-grid bg-col p-col-12 p-lg-12">
          <Dialog
            visible={this.state.isLoading}
            modal={true}
            style={{ width: "20vw" }}
            closable={false}
            showHeader={false}
            onHide={this.onDialogueLoaderHide}
          >
            <Loader textToShow={this.state.textInLoader} />
          </Dialog>
          <Dialog
            id="diag1"
            visible={this.state.AddPlayStore}
            modal={true}
            style={{ width: "90%", minHeight: "600px" }}
            closable
            showHeader
            onHide={this.onDialogueHide}
          >
            <div id="container" />
          </Dialog>
          <Dialog
            header="Error!"
            visible={this.state.isError}
            modal
            style={{ width: "25vw" }}
            closable
            showHeader
            onHide={this.onDialogueHideError}
          >
            <ErrorDialog errorMessage={this.state.textInLoader} />
          </Dialog>
          <div
            className="p-col-12"
            style={{ borderBottom: "1px solid #e0e0e0" }}
          >
            <div className="p-col-12 p-md-4 p-lg-4 inline-b">
              <h2 style={{ textAlign: "left", paddingTop: "10px" }}>
                App Management
              </h2>
            </div>
            <div className="p-col-12 p-md-4 p-lg-4 inline-b">
              <div id="search" className="p-inputgroup">
                <InputText
                  placeholder="Enter Search Item"
                  onChange={(e) => {
                    this.setState({ textFilter: e.target.value });
                  }}
                  onKeyDown={(e) =>
                    // this.setState({ globalFilter: e.target.value })
                    {
                      console.log("e", e.key);
                      if (e.key === "Enter") {
                        this.callgetAppListByType({
                          apptype: this.state.isEnt
                            ? 1
                            : this.state.isPlayStore
                            ? 3
                            : 0,
                          filter: this.state.textFilter,
                        });
                      } else {
                        if (this.state.textFilter === "") {
                          this.callgetAppListByType({
                            apptype: this.state.isEnt
                              ? 1
                              : this.state.isPlayStore
                              ? 3
                              : 0,
                          });
                        }
                      }
                    }
                  }
                />
                <Button
                  icon="pi pi-search"
                  className="p-button-primary s-icon s-btn"
                  onClick={(e) => {
                    if (this.state.textFilter !== "") {
                      this.callgetAppListByType({
                        apptype: this.state.isEnt
                          ? 1
                          : this.state.isPlayStore
                          ? 3
                          : 0,
                        filter: this.state.textFilter,
                      });
                    } else {
                      this.callgetAppListByType();
                    }
                  }}
                />
              </div>
            </div>
            <div
              className="p-col-12 p-md-4 p-lg-4 inline-b"
              style={{ textAlign: "right" }}
            >
              {this.state.isEnt ? (
                <EntPopupForm callParentApi={this.callgetAppListByType} />
              ) : this.state.hasEnterpriseSetup === true &&
                this.state.isPlayStore !== undefined &&
                this.state.isPlayStore === true ? (
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    //pop up
                    this.setState({ AddPlayStore: true }, () => {
                      this.callpostwebtokenPlaystore({
                        parentFrameUrl:
                          "https://ibbl.mobionizer.com/app-management",
                        iframeType: 0,
                        appId: null,
                      });
                    });
                  }}
                >
                  {" "}
                  Add New{" "}
                </button>
              ) : (
                <AddNewApp callParentApi={this.callgetAppListByType} />
              )}
            </div>
          </div>
          <div className="p-col-12">
            <div className="p-col-12 cus-nav">
              <ul
                className="nav nav-pills mb-2"
                id="pills-tab"
                role="tablist"
                style={{
                  borderBottom: "1px solid gray",
                  paddingBottom: "10px",
                }}
              >
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    id="enabled-app"
                    data-toggle="pill"
                    href="#pills-system"
                    role="tab"
                    aria-controls="pills-system"
                    aria-selected="true"
                    onClick={this.cusPopup(0)}
                  >
                    System Apps
                  </a>
                </li>
                {this.state.hasEnterpriseSetup !== undefined &&
                this.state.hasEnterpriseSetup === true ? (
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      id="playstore-app"
                      data-toggle="pill"
                      href="#pills-playstore"
                      role="tab"
                      aria-controls="pills-playstore"
                      aria-selected="false"
                      onClick={this.cusPopup(2)}
                    >
                      PlayStore Apps
                    </a>
                  </li>
                ) : (
                  ""
                )}
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="all-apps"
                    data-toggle="pill"
                    href="#pills-enterprise"
                    role="tab"
                    aria-controls="pills-enterprise"
                    aria-selected="false"
                    onClick={this.cusPopup(1)}
                  >
                    Enterprise Apps
                  </a>
                </li>
              </ul>
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane active"
                  id="pills-system"
                  role="tabpanel"
                  aria-labelledby="enabled-app"
                >
                  <div className="row align-items-start">
                    <div id="cus-padding" className="p-col-12">
                      {sysApplist}
                      <Paginator
                        first={this.state.sysfirst}
                        rows={this.state.sysrows}
                        totalRecords={this.state.systotalRecords}
                        rowsPerPageOptions={[2, 4, 8, 10, 20, 30]}
                        onPageChange={this.onPageChange("sys")}
                      ></Paginator>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane"
                  id="pills-playstore"
                  role="tabpanel"
                  aria-labelledby="playstore-app"
                >
                  <div className="row align-items-start">
                    <div className="p-col-12" id="cus-padding">
                      {playstore}
                      <Paginator
                        first={this.state.playfirst}
                        rows={this.state.playrows}
                        totalRecords={this.state.playtotalRecords}
                        rowsPerPageOptions={[2, 4, 8, 10, 20, 30]}
                        onPageChange={this.onPageChange("playstore")}
                      ></Paginator>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane"
                  id="pills-enterprise"
                  role="tabpanel"
                  aria-labelledby="all-apps"
                >
                  <div className="row align-items-start">
                    <div className="p-col-12" id="cus-padding">
                      {entApplist}
                      <Paginator
                        first={this.state.entfirst}
                        rows={this.state.entrows}
                        totalRecords={this.state.enttotalRecords}
                        rowsPerPageOptions={[2, 4, 8, 10, 20, 30]}
                        onPageChange={this.onPageChange("ent")}
                      ></Paginator>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
